module.exports = __webpack_public_path__ + "static/media/login.2caa4aac.png";